import script from "./AboutSubscriptionPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutSubscriptionPopup.vue?vue&type=script&setup=true&lang=ts"

import "./AboutSubscriptionPopup.vue?vue&type=style&index=0&id=30037b81&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30037b81"]])

export default __exports__